import { statusMeta } from "../lib/status";
import { tr } from "../i18n";

/** Tarif non remboursable (Booking) : paiement intégral immédiat, pas d'attente J-x. */
export function NonRefundableBadge({ r, compact = false, className = "" }) {
  if (!r?.rate_non_refundable) return null;
  const grace = r.nr_grace_until ? new Date(r.nr_grace_until) : null;
  const pending = grace && grace > new Date();
  const title = r.nr_source === "airbnb" ? "Option non remboursable Airbnb choisie par le voyageur — encaissé par Airbnb, aucun débit Casanéo"
    : pending ? `Tarif non remboursable — débit intégral après le délai de grâce Booking (${grace.toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })})` : "Tarif non remboursable — paiement intégral immédiat (pas d'attente J-60)";
  return (
    <span title={title} data-testid={`non-refundable-badge-${r.id}`}
      className={`inline-flex items-center gap-1 rounded-md border border-rose-300 bg-rose-50 text-rose-700 font-medium ${compact ? "px-1 py-0 text-[10px]" : "px-2 py-0.5 text-xs"} ${className}`}>
      <svg viewBox="0 0 24 24" className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
      {compact ? "NR" : "Non remboursable"}
    </span>
  );
}

export function StatusBadge({ status, className = "" }) {
  const m = statusMeta(status);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${m.cls} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {m.label}
    </span>
  );
}

export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div
      data-testid={testid}
      className="px-5 sm:px-8 pt-6 pb-5 border-b border-border bg-card flex flex-col md:flex-row md:items-end justify-between gap-4"
    >
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function Spinner({ label = tr("common.loading") }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-3 text-muted-foreground">
      <div className="h-8 w-8 rounded-full border-2 border-brass border-t-transparent animate-spin" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      {Icon && (
        <div className="h-14 w-14 rounded-2xl bg-secondary grid place-items-center mb-4">
          <Icon className="h-7 w-7 text-muted-foreground" />
        </div>
      )}
      <p className="font-serif text-2xl text-[#0f172a]">{title}</p>
      {hint && <p className="mt-1 text-sm text-muted-foreground max-w-sm">{hint}</p>}
    </div>
  );
}
